import { Suspense, lazy } from "react";

const Page = lazy(() => import("./TrainingSettings").then((m) => ({ default: m.TrainingSettings })));

export const TrainingSettingsPage = (props) => (
  <Suspense fallback={null}>
    <Page {...props} />
  </Suspense>
);

TrainingSettingsPage.title = "Training";
TrainingSettingsPage.path = "/training";
TrainingSettingsPage.exact = true;
TrainingSettingsPage.menuSection = "models";
